/*
 * @Author: youfanrong 737064439@qq.com
 * @Date: 2025-03-03 08:59:07
 * @LastEditors: youfanrong 737064439@qq.com
 * @LastEditTime: 2025-11-29 18:56:41
 * @FilePath: /bar-front-end/src/api/login/index.ts
 */
import request from '@/axios'
import type { UserType } from './types'

interface RoleParams {
  roleName: string
}

// 登录
export const loginApi = (data: UserType): Promise<IResponse<any>> => {
  // return request.post({ url: '/mock/user/login', data })
  // platform=1 表示前台系统,后端据此校验账号是否属于该系统
  return request.post({ url: '/barV2/console/login', data: { ...data, platform: 1 } })
}

// 获取用户信息
export const getUserInfoApi = (): Promise<IResponse<any>> => {
  return request.get({ url: '/barV2/qywx/user/getUserInfo' })
}

// 获取企微登录后的综管/财务中心入口信息（后管不参与入口决策）
export const getQywxSystemEntryApi = (): Promise<IResponse<any>> => {
  return request.get({ url: '/barV2/qywx/user/getSystemEntry' })
}

// 获取用户信息
export const getCurUserDetailApi = (): Promise<IResponse<any>> => {
  return request.get({ url: '/barV2/console/user/getCurUserDetail' })
}

export const loginOutApi = (): Promise<IResponse> => {
  // return request.get({ url: '/mock/user/loginOut' })
  return request.post({ url: '/barV2/console/logout' })
}

export const getUserListApi = ({ params }: AxiosConfig) => {
  return request.get<{
    code: string
    data: {
      list: UserType[]
      total: number
    }
  }>({ url: '/mock/user/list', params })
}

export const getAdminRoleApi = (
  params: RoleParams
): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  return request.get({ url: '/mock/role/list', params })
}

export const getTestRoleApi = (params: RoleParams): Promise<IResponse<string[]>> => {
  return request.get({ url: '/mock/role/list2', params })
}

// 获取企微ww.register时所需的企业身份参数信息
export const getWechatConfigInfoApi = (params: any): Promise<IResponse<any>> => {
  return request.get({ url: '/barV2/qywx/user/getJssdkConfigInfo', params })
}

// 获取企微ww.register时所需的应用身份参数信息
export const getWechatAgentConfigInfoApi = (params: any): Promise<IResponse<any>> => {
  return request.get({ url: '/barV2/qywx/user/getJssdkAgentConfigInfo', params })
}

// 查询当前用户最新申请单状态
export const getLatestApplyApi = (params: any): Promise<IResponse<any>> => {
  return request.get({ url: '/barV2/qywx/user/register/getLatestApply', params })
}

// 提交用户注册申请单
export const submitApplyApi = (id, data: any): Promise<IResponse<any>> => {
  return request.post({ url: '/barV2/qywx/user/register/submitApply?quid=' + id, data })
}

// 部门树
export const getDepTreeApi = (params: any): Promise<IResponse<any>> => {
  return request.get({ url: '/barV2/qywx/dep/departTree', params })
}
